export const oeCodingTableConfig = {
    DefaultPageSize: 10,
    DefaultPageNumber: 1,
  };
  
